var Reverb = window.Reverb || {};
Reverb.BundledCheckout = Reverb.BundledCheckout || {};

Reverb.BundledCheckout.ToggleForm = (function () {
  function init() {
    bindToggleForm();
  }

  function bindToggleForm() {
    $(document).on('click', '[data-bind=\'toggle-form\']', toggleForm);
  }

  function toggleForm(e) {
    e.preventDefault();
    var formIdentifier = $(this).data('form');

    $(this).hide();
    $('[data-bind=\'on-form-toggle\'][data-form=\'' + formIdentifier + '\']').each(function () {
      var action = $(this).data('action');
      if (action == 'show') {
        $(this).fadeIn();
      } else if (action == 'hide') {
        $(this).hide();
      }
    });
  }

  return {
    init: init
  };
})();

$(Reverb.BundledCheckout.ToggleForm.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/bundled_checkout/toggle_form.js